export default "__VITE_PUBLIC_ASSET__84d9d16c__"